import { DomainDnsRecord } from '@tribeplatform/gql-client/types'
import { Table } from '@tribeplatform/react-ui-kit/Table'
import { Text } from '@tribeplatform/react-ui-kit/Text'

import { StatusIcon } from './StatusIcon.js'

interface Props {
  dnsRecords: DomainDnsRecord[]
}

export const TableBody = ({ dnsRecords }: Props) => {
  return (
    <Table.Body className="bg-background">
      {dnsRecords.map(({ name, type, desiredValue, status, message }) => (
        <Table.Row key={`${name}-${type}`}>
          <Table.Cell>
            <Text className="font-mono" variant="bodySm">
              {type}
            </Text>
          </Table.Cell>
          <Table.Cell>
            <Text
              variant="bodySm"
              className="font-mono"
              // Using `div` allows the value to be copied properly, without extra white spaces
              as="div"
            >
              {name}
            </Text>
          </Table.Cell>
          <Table.Cell>
            <Text
              variant="bodySm"
              className="font-mono whitespace-pre-wrap"
              // Using `div` allows the value to be copied properly, without extra white spaces
              as="div"
            >
              {desiredValue}
            </Text>
          </Table.Cell>
          <Table.Cell align="center">
            <StatusIcon status={status} message={message} />
          </Table.Cell>
        </Table.Row>
      ))}
    </Table.Body>
  )
}
